import React from 'react';
import { createRoot } from 'react-dom/client';
import './i18n'; // Import the i18n configuration
import App from './App';
import './index.css';
import './components/styles/CTAEffects.css';
import { AuthProvider } from './contexts/AuthContext.tsx';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
